module.exports = __webpack_public_path__ + "static/media/08_azure-burnaby.bc579e20.jpg";